import React from "react";
import { Delete } from "../../../../svg/delete";

interface DeleteIconCellProps {
  value: any;
  handleDeleteIconClick?: (data: any) => void;
  [key: string]: any;
}

export const DeleteIconCell: React.FC<DeleteIconCellProps> = ({
  value,
  handleDeleteIconClick,
}) => {
  const handleClick = () => {
    if (handleDeleteIconClick) {
      handleDeleteIconClick(value);
    } else if (value?.onDelete) {
      value.onDelete();
    }
  };

  return (
    <>
      <div onClick={handleClick} style={{ cursor: "pointer" }}>
        <Delete />
      </div>
    </>
  );
};

export default DeleteIconCell;
